import keyBy from 'lodash/keyBy';
import merge from 'lodash/merge';
import type { TreeGrid } from '../types';

const parseChanges = (str: string) => JSON.parse(str).Changes;

export const mergeChanges = (...args: string[]) => {
  const changes = args.map(str => keyBy(parseChanges(str), 'id'));
  // @ts-ignore
  return Object.values(merge(...changes)) as TreeGrid.ChangedRow[];
};
